<mat-form-field>
  <input type="text" [placeholder]="placeholder" aria-label="Number" matInput [formControl]="myControl" 
  [matAutocomplete]="auto" [readonly]="readonly">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
          {{ option.email }}
      </mat-option>
  </mat-autocomplete>
</mat-form-field>


// WEBPACK FOOTER //
// ./src/app/shared/components/user-picker.component.ts.UserPickerComponent.html